import React from 'react';

const InputsSections = ({ children, style }) => {
	return <div className='modalContainer__form--sections' style={style}>{children}</div>;
};

export default InputsSections;
